import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { preloadPublicPage } from "@/publicRoutes";

const container = document.getElementById("root");
const tree = (
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

// Les pages publiques arrivent PRÉ-RENDUES : le backend sert un `#root`
// déjà rempli (contenu, H1, JSON-LD), produit au build par
// scripts/prerender.mjs. On HYDRATE alors le DOM existant au lieu de le
// jeter et de le repeindre : le premier rendu est celui du HTML, avant tout
// JavaScript. Un `#root` vide (app privée, Poste, portail, URL inconnue)
// suit le chemin classique.
//
// Le chunk de la page courante est PRÉCHARGÉ avant d'hydrater : un `lazy`
// résolu se rend sans frontière Suspense, et c'est la condition pour que
// l'hydratation garde le DOM (cf. publicRoutes.js).
//
// Un désaccord d'hydratation (langue mémorisée ≠ français, drapeau
// serveur ≠ valeur rendue au build) est RÉCUPÉRABLE : React 19 rejoue
// alors le rendu côté client. On le journalise en avertissement pour le
// voir dans les tests, sans jamais casser la page.
function mount() {
    if (container.hasChildNodes()) {
        ReactDOM.hydrateRoot(container, tree, {
            onRecoverableError: (err, info) => {
                // eslint-disable-next-line no-console
                console.warn("[archer] hydratation récupérée :", err?.message || err, info?.componentStack || "");
            },
        });
    } else {
        ReactDOM.createRoot(container).render(tree);
    }
}

preloadPublicPage(window.location.pathname).then(mount, mount);
